import {PageLink} from '../../../../_metronic/layout/core'

export const getBreadCrumbs: (path: string) => Array<PageLink> = (path) => {
  return [
    {
      title: 'Configuration Department',
      isSeparator: false,
      isActive: false,
      path,
    },
  ]
}
